import { fetchServer } from "@/features/utils/fetch";
import {
  AlgoregSessionIdContainer,
  InitAlgoregSessionRequestDto,
  AlgoregSessionState
} from "./types";

export class AlgoregSessionApiClient {
  static async initAlgoregSession(dto: InitAlgoregSessionRequestDto): Promise<AlgoregSessionState> {
    const response = await fetchServer("/algoreg-sessions/init", {
      method: "POST",
      reloadOn401: false,
      mainRoot: false,
      body: dto
    });

    const jsonResponse = await response.json();
    return jsonResponse.data;
  }

  static async finishAlgoregSession(dto: AlgoregSessionIdContainer): Promise<AlgoregSessionState> {
    const response = await fetchServer("/algoreg-sessions/finish", {
      method: "POST",
      reloadOn401: false,
      mainRoot: false,
      body: dto
    });

    const jsonResponse = await response.json();
    return jsonResponse.data;
  }
}
